import { HandHeart, Sparkles, UserCircle } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import { ICONOS_SISTEMA } from "@/components/brand/iconos-sistemas";

/**
 * Catálogo de módulos del Centro de ayuda — un módulo = una carpeta en `src/content/<id>/`. Se agrega un módulo
 * nuevo simplemente sumando una entrada acá y su carpeta correspondiente; los artículos dentro de cada módulo
 * se descubren solos (ver `src/app/[modulo]/page.tsx`), no hace falta listarlos a mano.
 */
export type Modulo = {
  id: string;
  nombre: string;
  descripcion: string;
  /** Mismo ícono que usa `Vecipp-Landing` para POS/Contabilidad/Nómina en su sección "Sistemas" — coherencia visual entre proyectos. */
  icon: LucideIcon;
};

export const MODULOS: Modulo[] = [
  {
    id: "cuenta",
    nombre: "Cuenta",
    descripcion: "Crear tu cuenta, iniciar sesión y primeros pasos en Vecipp.",
    icon: UserCircle,
  },
  {
    id: "pos",
    nombre: "POS",
    descripcion: "Ventas, turnos de caja, inventario y facturación.",
    icon: ICONOS_SISTEMA.pos,
  },
  {
    id: "contable",
    nombre: "Contabilidad",
    descripcion: "Cómo se conecta el POS con la contabilidad de tu negocio.",
    icon: ICONOS_SISTEMA.contabilidad,
  },
  {
    id: "nomina",
    nombre: "Nómina",
    descripcion: "Empleados, novedades, liquidaciones y pagos de nómina.",
    icon: ICONOS_SISTEMA.nomina,
  },
  {
    // El único módulo para el **vecino**, no para el negocio: la app de `app.vecipp.com`. Va aparte
    // porque su lector es otro — quien pide un domicilio no tiene empresa, ni plan, ni inventario.
    id: "vecipp",
    nombre: "App de Vecipp",
    descripcion: "Pedir domicilios, favores y mandados, y ganarte algo haciéndolos.",
    icon: HandHeart,
  },
  {
    // Vecipp IA (ia.vecipp.com), el tercer mundo del ecosistema (2026-10-18): el chat, el agente en la terminal, el
    // escritorio y la extensión de Chrome. Su código vive en el repo Vecipp/Vecipp-IA; su Regla 8 manda documentar acá.
    id: "ia",
    nombre: "Vecipp IA",
    descripcion: "El chat y el agente que programa por ti: en la web, la terminal, el escritorio y Chrome.",
    icon: Sparkles,
  },
];

export function obtenerModulo(id: string): Modulo | undefined {
  return MODULOS.find((m) => m.id === id);
}
